"use client"

import { useEffect } from "react"
import { isVoiceSyncPending } from "@/lib/voice/elevenlabs-sync/status"

export function useVoiceSetupRefresh(
  agents: ReadonlyArray<{ last_sync_error?: string | null }>,
  refresh: () => Promise<void>,
) {
  const pending = agents.some(agent => isVoiceSyncPending(agent.last_sync_error))
  useEffect(() => {
    if (!pending) return
    let refreshing = false
    async function update() {
      if (document.hidden || refreshing) return
      refreshing = true
      try { await refresh() } catch {
        // The data hook owns user-facing fetch errors; polling must not leak a rejection.
      } finally { refreshing = false }
    }
    function onVisibilityChange() { if (!document.hidden) void update() }
    const timer = setInterval(() => { void update() }, 5_000)
    document.addEventListener("visibilitychange", onVisibilityChange)
    return () => {
      clearInterval(timer)
      document.removeEventListener("visibilitychange", onVisibilityChange)
    }
  }, [pending, refresh])
}
